var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-flex-grid',{attrs:{"url-path":_vm.api,"url-query":{
        idPlanRes: _vm.idPlanRes,
        shiftIndex: _vm.shiftIndex,
        idWarehouseVeneer: _vm.idWarehouseVeneer,
    },"sortable":"","is-compressed":_vm.params.isCompressed}})}
var staticRenderFns = []

export { render, staticRenderFns }